import { render, staticRenderFns } from "./AdminRequestDetails.vue?vue&type=template&id=dfed055c"
import script from "./AdminRequestDetails.vue?vue&type=script&lang=js"
export * from "./AdminRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports